import { CodeEditorController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/services/CodeEditor/CodeEditorController';
import CodeEditorView from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/services/CodeEditor/CodeEditorView.html';
export class CodeEditorService {
    static $inject = ['SidebarContentService', '$document'];
    constructor(SidebarContentService, $document) {
        'ngInject';
        this.SidebarContentService = SidebarContentService;
        this.$document = $document;
    }
    async openCodeEditor(inputs) {
        return await this.SidebarContentService.showSidebar({
            controller: CodeEditorController,
            controllerAs: '$ctrl',
            template: CodeEditorView,
            appendToElement: this.$document[0].getElementById('main-content-area'),
            allowMultiple: true,
            inputs,
        });
    }
}
CodeEditorService.$inject = ['SidebarContentService', '$document'];
